import { Tooltip } from '@mui/material';
import { Archive, Desarchive, BoxArchive, Loading } from './styles';

interface DivArchiveProps {
  status: number;
  loading: boolean;
}

export function DivArchive({ status, loading }: DivArchiveProps): JSX.Element {
  if (loading) {
    return <Loading />;
  }
  return (
    <BoxArchive>
      {status === 2 ? (
        <Tooltip title='Desarquivar'>
          <Desarchive />
        </Tooltip>
      ) : (
        <Tooltip title='Arquivar'>
          <Archive />
        </Tooltip>
      )}
    </BoxArchive>
  );
}
